// RomaMotor Theme JS
function filterTab(el, cat) {
  document.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
  el.classList.add('active');
  
  // Solo afecta las tarjetas DENTRO del top-sellers
  const container = el.closest('section') || document.querySelector('.top-sellers');
  container.querySelectorAll('.product-card').forEach(card => {
    const cardCat = (card.dataset.cat || '').toLowerCase().trim();
    const filterCat = (cat || '').toLowerCase().trim();
    if (!filterCat || cardCat === filterCat || filterCat === 'all') {
      card.style.display = 'block';
    } else {
      card.style.display = 'none';
    }
  });
}

// Activa la primera tab al cargar
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const firstTab = document.querySelector('.tab');
    if (firstTab) firstTab.click();
  }, 100);
});





